import { Box, BoxProps, Button } from '@ytl/common-web';
import { useMemo } from 'react';
import { ReactComponent as CheckIcon } from '../../../assets/check.svg';
import { useLanguage } from '../../../contexts/languageContext';

export const useMfaSMSB2bSuccessView = (email: string, onContinue: () => void) => {
  const { translation } = useLanguage();

  const boxConfig: Omit<BoxProps, 'children'> = useMemo(() => {
    return {
      icon: (
        <CheckIcon
          className={'icon '}
          style={{
            color: '#54BF78',
          }}
        />
      ),
      header: translation.accountSettings.mfa.smsB2bSuccess.title,
      subHeader: translation.accountSettings.mfa.smsB2bSuccess.content(email),
      action: <Button onClick={() => onContinue()}>{translation.accountSettings.mfa.smsB2bSuccess.continue}</Button>,
    };
  }, [translation, email, onContinue]);

  const view = useMemo(() => <Box {...boxConfig} />, [boxConfig]);

  return {
    view,
  };
};
